import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Constant} from '../util/constant';
import {catchError, retry} from 'rxjs/operators';
import {FormDataDTO} from "../dto/FormDataDTO";

@Injectable({providedIn: 'root'})
export class PalpationService {
    httpOptions = {headers: new HttpHeaders({'Content-Type': 'application/json'})};

    constructor(private httpClient: HttpClient) {
    };

    deleteByIdPalpation(palpationId): Observable<string> {
        return this.httpClient.post<string>(
            Constant.BASE_URL + 'Palpation/deletePalpation', {'palpationId': palpationId}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    countPalpation(palpation): Observable<number> {
        // let baseURL = 'http://localhost:8080/CPA/Hive-Worx/';
        return this.httpClient.post<number>(Constant.BASE_URL + 'Palpation/count', {'palpation': palpation}, this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    updatePalpation(palpation): Observable<string> {
        return this.httpClient.post<string>(Constant.BASE_URL + 'Palpation/updatePalpation', [palpation], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addPalpation(palpation): Observable<string> {
        // let baseURL = 'http://localhost:8080/CPA/Hive-Worx/';
        return this.httpClient.post<string>(Constant.BASE_URL + 'Palpation/addPalpation', [palpation], this.httpOptions).pipe(
            retry(3), catchError(Constant.handleError));
    }

    addPalpationCpa(palpationDTO: FormDataDTO): Observable<any> {
    return this.httpClient.post<string>(Constant.CPA_SPRING_API_URL + 'palpations', palpationDTO, {headers: new HttpHeaders()
        .set('Content-Type', 'application/json'),
      observe: 'response'}).pipe(
      retry(3), catchError(Constant.handleError));
    }

    findAllPalpation(palpation, pageNo: number, itemsPerPage: number): Observable<string[]> {
        // let baseURL = 'http://localhost:8080/CPA/Hive-Worx/';
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Palpation/findAllPalpation',
            {'palpation': palpation, 'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}}, this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    // custom service for global search

    globalSearchCount(searchTerm,appointmentId,expertId,patientId): Observable<number> {
        return this.httpClient.post<number>(
            Constant.BASE_URL + 'Palpation/countGlobalPalpation',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

    globalSearchFind(searchTerm,appointmentId,expertId,patientId, pageNo: number, itemsPerPage: number): Observable<string[]> {
        return this.httpClient.post<string[]>(
            Constant.BASE_URL + 'Palpation/findGlobalPalpation',
            {'searchTerm': searchTerm,'appointmentId':appointmentId,'expertId':expertId,'patientId':patientId,
                'pagination': {'pageNo': pageNo, 'itemsPerPage': itemsPerPage}},
            this.httpOptions
        ).pipe(
            retry(3), catchError(Constant.handleError));
    }

  findAllPalpationsByPatientId(patientId: number): Observable<any> {
    return this.httpClient.get<any>(

      Constant.CPA_SPRING_API_URL + 'patients/' + patientId  + '/palpations', {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json'),
        observe: 'response'
      }
    ).pipe(
      retry(3), catchError(Constant.handleError));
  }

  findAllPalpationsByAppointmentId(appointmentId: number): Observable<any> {


    return this.httpClient.get<any>(

      Constant.CPA_CLINICAL_DATA_SERVICE + 'appointments/' + appointmentId  + '/palpations', {
        headers: new HttpHeaders()
          .set('Content-Type', 'application/json'),
        observe: 'response'
      }
    ).pipe(
      retry(3), catchError(Constant.handleError));
  }


}
